module.exports = __webpack_public_path__ + "static/media/listen.2b4862b1.png";